import React, { useEffect, useRef, useState } from 'react';
import DriscollsBanner from './DriscollsBanner';
import { Divider } from '@material-ui/core';
import { Call } from '@driscollsinc/driscolls-display-rules';
import APIEndPoints from '../../services/api';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

const Banner = (props) => {
    const [banners, setBanners] = useState([]);
    const language = props.userLang == 'en-US' ? 'en' : 'zh';
    const [token, setToken] = useState(null);
    const bannerRef = useRef(null);

    useEffect(() => {
        if (bannerRef.current) {
            const height = bannerRef.current.offsetHeight;
            props.getBannerHeight(height);
        } else props.getBannerHeight(0);
    }, [banners, bannerRef.current]);

    useEffect(() => {
        getAccessToken();
    }, [props.oktaAuth]);

    const getAccessToken = async () => {
        const accessToken = await props.oktaAuth.getAccessToken();
        setToken(accessToken);
    };

    const parseBanners = (data) => {
        const parsed =
            data &&
            data.map((item) => {
                const metadata = JSON.parse(item.metadata);
                return {
                    ...item,
                    content: metadata.content,
                    isDismissible: metadata.isDismissible,
                    color: metadata.color.toLowerCase()
                };
            });
        return parsed || [];
    };

    const fetchBanners = async () => {
        const response = await Call({ name: 'Banner', url: APIEndPoints.GET_BANNERS(), method: 'GET', options: {} }, token);
        if (response.raw) {
            const data = response.raw.data;
            const parsedBanners = parseBanners(data.banners || []);
            setBanners(parsedBanners);
        }
        if (response.errors) {
            console.error('error fetching banners', response.errors);
        }
    };

    useEffect(() => {
        if (token) fetchBanners();
    }, [token]);

    if (!token) return null;
    return (
        <div ref={bannerRef}>
            {(banners ?? []).map((banner, idx) => (
                <div key={banner.id || idx}>
                    <DriscollsBanner
                        content={banner.content[language]?.text ?? banner.content.en.text}
                        isDismissible={banner.isDismissible}
                        bgColor={banner.color}
                        onClose={() => {
                            setBanners((prev) => prev.filter((_, i) => i !== idx));
                        }}
                    />
                    <Divider />
                </div>
            ))}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        userLang: state.masterReducer.userLang
    };
}

export default withOktaAuth(connect(mapStateToProps, null)(Banner));
